import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            The Computing History Initiative for Preservation is at the forefront of capturing the essence and evolution of computing, a field that has profoundly transformed every aspect of our lives. With the rapid advancements in Computer Science and Engineering over the past decades, computing has transcended its utilitarian role, becoming a pivotal element of our cultural heritage. This project is born out of a growing fascination with the history of computing, underscored by the increasing efforts to study, preserve, and cherish the knowledge and artifacts that have shaped this journey.
          </p>
          {/* <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul> */}

          <p style={{ color: "rgb(155 126 172)" }}>
            "Innovating for Access and Discovery"{" "}
          </p>
          <footer className="blockquote-footer">CHIPS&BITS</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
